const TIMESHEET_STATUS = ['DRAFT', 'REVIEW', 'APPROVED', 'REJECT'];

const titleCase = (str = '') => {
  let words = str.split(' ');
  words.forEach((w, i) => {
    w = w.substring(0, 1).toLocaleUpperCase() + w.substring(1);
    words[i] = w;
  })
  return words.join(' ');
}

const TIMESHEET_PERIOD = [
  {
    code: "current-month",
    name: "Current Month",
  },
  {
    code: "current-week",
    name: "Current Week",
  },
  {
    code: "last-three-week",
    name: "Last 3 Week",
  },
  {
    code: "custom-date",
    name: "Custom",
  }
  // {
  //   code: "last-month",
  //   name: "Last Month",
  // },
  // {
  //   code: "last-two-month",
  //   name: "Last 2 Month",
  // },
];

const CHARGABLE_OPTIONS = [
  {
    id: 1,
    code: "CH",
    name: "Chargable",
    chargeable: "yes",
  },
  {
    id: 2,
    code: "NC",
    name: "Not Chargable",
    chargeable: "no",
  },
];

export {
  TIMESHEET_STATUS,
  titleCase,
  CHARGABLE_OPTIONS,
  TIMESHEET_PERIOD
}